import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import dayjs from 'dayjs';
import 'styles/index.css';
import { theme } from 'styles/theme';
import 'react-phone-input-2/lib/material.css';
import 'react-datepicker/dist/react-datepicker.css';
import relativeTime from 'dayjs/plugin/relativeTime';
import { CssBaseline, ThemeProvider } from '@mui/material';
import CustomSnackbar from 'components/custom-snackbar/custom-snackbar';
dayjs.extend(relativeTime);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <App />
    <CustomSnackbar />
  </ThemeProvider>
);
